import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  wrapper: {
    right: 0,
    bottom: 0,
    zIndex: 9998,
    width: '100%',
    height: '100%',
    position: 'fixed',
    backgroundColor: token.colorWhite
  }
}))
